import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import AimPortal from './aim/AimPortal'
import './presentation.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {location.pathname.startsWith('/aim') ? <AimPortal /> : <App />}
  </StrictMode>,
)

import './motion.css'
